import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";
import ModalContentBase from "../modal/modal_content_base";
import WallsCommentsLikeUsers from "./walls_comments_like_users";
import axios from "../../../axios"

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    wallId: PropTypes.number.isRequired,
    wallsCommentId: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    isFormShow: PropTypes.bool.isRequired,
  },
  getInitialState() {
    return {
      commentReply: "",
      replies: [],
      isUploading: false,
      modalLikeUsersRef: React.createRef(),
      commentIdForViolation: 0,
    };
  },
  handleCommentReplyForm(e) {
    this.setState({
      commentReply: e.target.value,
    });
  },
  handleCommentReplyBtn() {
    this.setState({
      isUploading: true,
    });
    const formData = new FormData();
    formData.append("comment", this.state.commentReply);
    formData.append("wall_id", this.props.wallId);
    formData.append("parent_walls_comment_id", this.props.wallsCommentId);
    $.ajax({
      url: "/api/walls/create_comment_reply",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          this.loadCommentsReply();
          this.setState({
            commentReply: "",
          });
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  loadCommentsReply() {
    $.ajax({
      url: "/api/walls/walls_comments_replies",
      type: "GET",
      cache: false,
      data: {
        parent_walls_comment_id: this.props.wallsCommentId,
      },
      contentType: false,
    })
      .done(
        function (data) {
          this.setState({
            replies: data.wallsCommentsReplies,
          });
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  handleLikeButton(e) {
    e.preventDefault();

    const commentId = e.currentTarget.dataset.comment_id;
    const formData = new FormData();
    formData.append("walls_comment_id", commentId);
    $.ajax({
      url: "/api/walls/like_comment",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          this.loadCommentsReply();
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  handleShowLikeUsersButton(e) {
    e.preventDefault();
    this.setState({
      commentIdForLikeUsers: e.currentTarget.dataset.comment_id,
    });
    this.state.modalLikeUsersRef.current.openModal();
  },
  handleDeleteCommentBtn(e) {
    e.preventDefault();
    this.setState({
      deleteCommentId: e.currentTarget.dataset.comment_id,
    });
    this.deleteCommentConfirm.openModal();
  },
  handleReportCommentBtn(e) {
    e.preventDefault();
    const commentId = e.currentTarget.dataset.comment_id;
    this.setState({
      commentIdForViolation: commentId,
    });
    this.reportCommentConfirm.openModal();
  },
  deleteComment() {
    const formData = new FormData();
    formData.append("walls_comment_id", this.state.deleteCommentId);
    $.ajax({
      url: "/api/walls/delete_comment",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          this.loadCommentsReply();
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  reportComment() {
    const body = JSON.stringify({
      walls_comment_id: this.state.commentIdForViolation,
    });
    axios
      .post("/api/walls_comments_violations", body)
      .then(() => {
        this.reportCommentComplete.openModal();
      })
  },
  componentDidMount() {
    this.loadCommentsReply();
  },
  render() {
    const currentUser = this.props.currentUser ? this.props.currentUser : null;
    const isFormShow = this.props.isFormShow;
    const handleDeleteCommentBtn = this.handleDeleteCommentBtn;
    const handleReportCommentBtn = this.handleReportCommentBtn;
    const handleLikeButton = this.handleLikeButton;
    const handleShowLikeUsersButton = this.handleShowLikeUsersButton;
    const likeUsersModalContent = (
      <WallsCommentsLikeUsers
        wallsCommentId={this.state.commentIdForLikeUsers}
      />
    );
    const replyList = this.state.replies.map(function (replyComment) {
      const like_user_ids = replyComment.walls_comments_like_users.map(function (
        like_user
      ) {
        return like_user.user_id;
      });
      return (
        <div className="container mt-2" key={replyComment.id}>
          <div className="row justify-content-around align-items-start pb-3">
            <div className="col-1 col-md-1 pl-0 mt-1">
              <img
                src={replyComment.company
                  ? (replyComment.companies_user ? replyComment.companies_user.avatar_thumb : "" ) 
                  : (replyComment.user ? replyComment.user.avatar_thumb : "")}
                className="event-member-icon-medium"
              />
            </div>
            <div className="col">
              <div className="d-flex justify-content-between pl-1 mb-1" style={{ width: '94%' }}>
                <p className="text-fz-11px text-fw-bold text-fz-green mb-0">
                {replyComment.company ? (
                  <a
                    href={"/community/" + replyComment.company.id_to_param + "/member/" + replyComment.companies_user.member_id}
                    style={{ textDecoration: "none" }}
                  >
                    @{replyComment.companies_user
                      ? replyComment.company.is_real_name_required 
                      ? replyComment.companies_user.view_full_name_disp : 
                        replyComment.companies_user.nickname
                    : "退会ユーザー"}
                  </a>
                ) : (
                  <a
                    href={"/member/profile/" + replyComment.user.tunagate_id}
                    style={{ textDecoration: "none" }}
                  >
                    @{replyComment.user
                      ? replyComment.user.tunagate_id
                      : "退会ユーザー"}
                  </a>
                )
                }
                </p>
                <div className="d-flex">
                  <p className="text-fz-xs text-black-20 mb-0">
                    {replyComment.created_at_time_ago_format}
                  </p>
                  <div className="dropdown dropleft">
                    <img
                      style={{ padding: '0 2px 0 12px' }}
                      id="dropdownMenu"
                      height={15}
                      className="position-absolute"
                      data-toggle="dropdown"
                      src="/assets2019/img/icon_reader.svg"
                      alt=""
                    />
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                      {currentUser && currentUser.id == replyComment.user_id ? (
                        <button
                          onClick={handleDeleteCommentBtn}
                          data-comment_id={replyComment.id}
                          className="dropdown-item btn btn-light text-danger text-center"
                          type="button"
                        >
                          削除する
                        </button>
                      ) : (
                        <button
                          onClick={handleReportCommentBtn}
                          data-comment_id={replyComment.id}
                          className="dropdown-item btn btn-light text-primary text-center"
                          type="button"
                        >
                          通報する
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <p
                className="text-fz-11px card border-0 bg-white mb-0 p-2"
                dangerouslySetInnerHTML={{
                  __html: replyComment.comment_display,
                }}
              />
              {/* <div className="d-flex">
                {!currentUser ? (
                  ""
                ) : !like_user_ids.includes(currentUser.id) ? (
                  <a
                    href=""
                    onClick={handleLikeButton}
                    data-comment_id={replyComment.id}
                    className="text-black-20 ml-2"
                  >
                    ♡
                  </a>
                ) : (
                  <p className="text-fz-xs text-black-20 mt-1 mb-0 ml-2">
                    いいね済
                  </p>
                )}
                {like_user_ids.length > 0 ? (
                  <a
                    href=""
                    onClick={!replyComment.company && handleShowLikeUsersButton}
                    data-comment_id={replyComment.id}
                    className="text-fz-xs text-black-20 mt-1 mb-0 ml-2"
                  >
                    {like_user_ids.length}件のいいね
                  </a>
                ) : (
                  ""
                )}
              </div> */}
            </div>
          </div>
        </div>
      );
    });
    return (
      <div className="comment-reply-box mt-2 mb-2">
        {replyList}
        {isFormShow && currentUser && currentUser.user_restricted_type < 80 ? (
          <div className="input-group pt-3 pb-0">
            <textarea
              className="form-control border-0 rounded h-1em bg-white text-fz-12px"
              style={{ height: 51 }}
              type="text"
              rows="1"
              placeholder="返信する..."
              onChange={this.handleCommentReplyForm}
              value={this.state.commentReply}
            />
            <div className="input-group-append">
              <button
                className="btn text-black-50 text-fw-normal pt-1 text-fz-12px"
                onClick={this.handleCommentReplyBtn}
              >
                返信
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        <ModalConfirm
          ref={(c) => {
            this.deleteCommentConfirm = c;
          }}
          title="コメントの削除"
          content="コメントを削除しますか？"
          approveFunc={this.deleteComment}
        />
        <ModalConfirm
          ref={(c) => {
            this.reportCommentConfirm = c;
          }}
          title="コメントを通報"
          content="コメントを通報しますか？"
          approveFunc={this.reportComment}
        />
        <ModalAlert
          ref={(c) => {
            this.reportCommentComplete = c;
          }}
          title="完了"
          content="コメントの通報が完了しました。"
        />
        <ModalContentBase
          ref={this.state.modalLikeUsersRef}
          previewContent={<div />}
          modalContent={likeUsersModalContent}
        />
      </div>
    );
  },
});
